import { RootState } from 'types/RootState';

export const selectThemes = (state: RootState) => state.theme?.themes || [];
export const selectThemeLoading = (state: RootState) => state.theme?.loading;
export const selectThemeError = (state: RootState) => state.theme?.error;
